"use client";
import type { ISiteSettings } from "@contentful-api/types/contentful";
import type { MicrocopySet } from "@lib/contentful/microcopy/types";
import React, { createContext, useContext } from "react";

interface GlobalContentContextType {
    siteSettings: ISiteSettings | null;
    sharedMicrocopySet: MicrocopySet | null;
}

const GlobalContentContext = createContext<GlobalContentContextType | undefined>(undefined);

export const GlobalContentProvider = ({
    children,
    siteSettings,
    sharedMicrocopySet,
}: GlobalContentContextType & { children: React.ReactNode }) => {
    return (
        <GlobalContentContext.Provider value={{ siteSettings, sharedMicrocopySet }}>
            {children}
        </GlobalContentContext.Provider>
    );
};

export const useGlobalContent = () => {
    const context = useContext(GlobalContentContext);
    if (!context) throw new Error("useGlobalContent must be used inside a GlobalContentProvider");
    return context;
};
